import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { CodeForm } from "../CodeForm";
import { CreateCodeModalProps } from "./types";
import { useCreateCodeModal } from "./controller";

export const CreateCodeModal = React.memo(({ modalRef, onComplete }: CreateCodeModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreateCodeModal(modalRef, onComplete );

  return (
    <Modal
      ref={modalRef}
      title={translate("limited_code_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <CodeForm />
    </Modal>
  );
});
